module.exports = __webpack_public_path__ + "media/images/pot-f6685c2732be24f8fc9a40b395ee5e1b.png";